<po-modal #chart id="chart-modal">
  <div class="po-row po-p-2" style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #ddd;">
    <h4 class="po-font-title">Estatísticas do cliente</h4>
    <po-select name="companyFilter" p-label="Consultar:" [p-options]="companyFilterOptions" 
      (p-change)="onCompanyFilterChange($event)" [ngModel]="selectedCompanyFilter">
    </po-select>
  </div>
    <div class="po-row po-pl-1 po-pr-1 po-pt-2 po-pb-2" *ngIf="hasError">
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <po-widget class="po-mt-0" style="background: linear-gradient(135deg, #fff5f5 0%, #ffe6e6 100%); border-left: 5px solid #d32f2f; border-radius: 8px; box-shadow: 0 2px 8px rgba(211, 47, 47, 0.15);">
          <div class="po-row po-p-3" style="display: flex; align-items: center;">
            <div style="display: flex; align-items: center; justify-content: center; width: 48px; height: 48px; background-color: rgba(211, 47, 47, 0.1); border-radius: 50%; margin-right: 16px;">
              <span class="po-icon po-icon-warning" style="color: #d32f2f; font-size: 28px;"></span>
            </div>
            <div style="flex: 1;">
              <div style="color: #d32f2f; font-weight: bold; font-size: 16px; margin-bottom: 4px;">Acesso não permitido</div>
              <div style="color: #666; font-size: 14px;">{{ errorMessage }}</div>
            </div>
          </div>
        </po-widget>
      </div>
    </div>
    <div class="po-row po-pl-1 po-pr-1 po-pb-1" *ngIf="!hasError">
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-pt-0 po-pl-0 po-pr-0">
        <po-widget class="po-mt-0" style="width: auto">
          <div class="po-row po-p-1" style="background-color: #f0f0f0; display: flex; justify-content: space-between; border-radius: 2px;">
            <span class="po-font-text-bold title">Cliente</span>
            <span class="po-ml-1 po-icon po-icon-user justify-content-end" style="margin-top: 4px"></span>
          </div>
          <div>
            <div><b>Nome</b> {{ personSelect.cliente }}</div>
            <div *ngIf="personSelect.data"><b>Data aniversário</b> {{ personSelect.data }}</div>
            <div *ngIf="personSelect.contato"><b>Contato</b> {{ personSelect.contato }}</div>
          </div>
        </po-widget>
      </div>
    </div>
    <div class="po-row po-pl-1 po-pr-1" *ngIf="!hasError">
      <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 po-pt-0 po-pl-0 po-pr-1">
        <po-widget class="po-mt-0">
          <div class="po-row po-p-1" style="background-color: #f0f0f0; display: flex; justify-content: space-between; border-radius: 2px;">
            <span class="po-font-text-bold title">Compra</span>
            <span class="po-ml-1 po-icon po-icon-basket justify-content-end" style="margin-top: 4px"></span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Qtd. total de compra</b> <span>{{ personStatisticsInfo.purchaseQuantity }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Valor médio de compra (ticket)</b> <span>{{ personStatisticsInfo.averagePurchaseValue | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Data maior compra</b> <span>{{ formatDateFull(personStatisticsInfo.biggestPurchaseDate) }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Valor maior compra</b> <span>{{ personStatisticsInfo.biggestPurchaseValue | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Data primeira compra</b> <span>{{ formatDateFull(personStatisticsInfo.firstPurchaseDate) }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Valor primeira compra</b> <span>{{ personStatisticsInfo.firstPurchaseValue | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Data última compra</b> <span>{{ formatDateFull(personStatisticsInfo.lastPurchaseDate) }}</span>
          </div>
          <div class="po-row po-mb-4" style="display: flex; justify-content: space-between;">
            <b>Valor última compra</b> <span>{{ personStatisticsInfo.lastPurchaseValue | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
          </div>
        </po-widget>
      </div>
      <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 po-pt-0 po-pl-0 po-pr-0" *ngIf="!hasError">
        <po-widget class="po-mt-0">
          <div class="po-row po-p-1" style="background-color: #f0f0f0; display: flex; justify-content: space-between; border-radius: 2px;">
            <span class="po-font-text-bold title">Limite</span>
            <span class="po-ml-1 po-icon po-icon-credit-payment justify-content-end" style="margin-top: 4px"></span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Valor do limite</b> <span>{{ limitPersonInfo | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Valor do limite disponível</b> <span>{{ openInvoiceValue | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
          </div>
        </po-widget>
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-pl-0 po-pr-0" *ngIf="!hasError">
          <po-widget class="po-mt-0">
            <div class="po-row po-p-1" style="background-color: #f0f0f0; display: flex; justify-content: space-between; border-radius: 2px;">
              <span class="po-font-text-bold title">Data último título pago</span>
              <span class="po-ml-1 po-icon po-icon-calendar justify-content-end" style="margin-top: 4px"></span>
            </div>
            <div class="po-row" style="justify-content: end;">
              <span>{{ formatDateFull(personStatisticsInfo.lastInvoicePaidDate) }}</span>
            </div>
          </po-widget>
        </div>
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-pr-0 po-pl-0" *ngIf="!hasError">
          <po-widget class="po-mt-0">
            <div class="po-row po-p-1" style="background-color: #f0f0f0; display: flex; justify-content: space-between; border-radius: 2px;">
              <span class="po-font-text-bold title">Valor último título pago</span>
              <span class="po-ml-1 po-icon po-icon-money justify-content-end" style="margin-top: 4px"></span>
            </div>
            <div class="po-row" style="justify-content: end;">
              <span>{{ personStatisticsInfo.lastInvoicePaidValue | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
            </div>
          </po-widget>
        </div>
      </div>
    </div>
    <div class="po-row po-p-1" *ngIf="!hasError">
      <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 po-pt-0 po-pl-0 po-pr-1">
        <po-widget class="po-mt-0">
          <div class="po-row po-p-1" style="background-color: #f0f0f0; display: flex; justify-content: space-between; border-radius: 2px;">
            <span class="po-font-text-bold title">Atraso</span>
            <span class="po-ml-1 po-icon po-icon-exclamation justify-content-end" style="margin-top: 4px"></span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Atraso médio</b> <span>{{ personStatisticsInfo.averageDelay }}</span>
          </div>
          <div class="po-row po-mb-3" style="display: flex; justify-content: space-between;">
            <b>Atraso máximo</b> <span>{{ personStatisticsInfo.maximumDelay }}</span>
          </div>
        </po-widget>
      </div>
      <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 po-pt-0 po-pl-0 po-pr-0" *ngIf="!hasError">
        <po-widget class="po-mt-0">
          <div class="po-row po-p-1" style="background-color: #f0f0f0; display: flex; justify-content: space-between; border-radius: 2px;">
            <span class="po-font-text-bold title">Parcelas em atraso</span>
            <span class="po-ml-1 po-icon po-icon-history justify-content-end" style="margin-top: 4px"></span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Total parcelas em atraso</b> <span>{{ personStatisticsInfo.quantityInstallmentsDelayed }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Valor parcelas em atraso</b> <span>{{ personStatisticsInfo.totalInstallmentsDelayed | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Média parcelas em atraso</b> <span>{{ personStatisticsInfo.averageInstallmentDelay }}</span>
          </div>
        </po-widget>
      </div>
    </div>
    <div class="po-row po-p-1 po-pt-0" *ngIf="!hasError">
      <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 po-pt-0 po-pl-0 po-pr-1">
        <po-widget class="po-mt-0">
          <div class="po-row po-p-1" style="background-color: #f0f0f0; display: flex; justify-content: space-between; border-radius: 2px;">
            <span class="po-font-text-bold title">Parcelas pagas</span>
            <span class="po-ml-1 po-icon po-icon-payment justify-content-end" style="margin-top: 4px"></span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Total parcelas pagas</b> <span>{{ personStatisticsInfo.quantityInstallmentsPaid }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Valor parcelas pagas</b> <span>{{ personStatisticsInfo.totalInstallmentsPaid | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Média parcelas pagas</b> <span>{{ personStatisticsInfo.averageValueInstallmentsPaid }}</span>
          </div>
        </po-widget>
      </div>
      <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 po-pt-0 po-pl-0 po-pr-0" *ngIf="!hasError">
        <po-widget class="po-mt-0">
          <div class="po-row po-p-1" style="background-color: #f0f0f0; display: flex; justify-content: space-between; border-radius: 2px;">
            <span class="po-font-text-bold title">Parcelas em aberto</span>
            <span class="po-ml-1 po-icon po-icon-finance justify-content-end" style="margin-top: 4px"></span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Total parcelas em aberto</b> <span>{{ personStatisticsInfo.quantityInstallmentsOpen }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Valor parcelas em aberto</b> <span>{{ personStatisticsInfo.totalInstallmentsOpen | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
          </div>
          <div class="po-row" style="display: flex; justify-content: space-between;">
            <b>Média parcelas em aberto</b> <span>{{ personStatisticsInfo.averageInstallmentsOpen }}</span>
          </div>
        </po-widget>
      </div>
    </div>
</po-modal>